import {Component, OnInit, ViewChild} from '@angular/core';
import { MatSort} from '@angular/material/sort';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {Member} from '../models/member';
import {Category} from '../models/category';
import {MemberGN1DialogComponent} from './dialogs/member-gn1-dialog/member-gn1-dialog.component';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {MemberGn1Service} from '../services/member-gn1.service';
import {FileService} from '../services/file.service';

@Component({
  selector: 'app-member-gn1',
  templateUrl: './member-gn1.component.html',
  styleUrls: ['./member-gn1.component.scss'],
  entryComponents: [
    MemberGN1DialogComponent
  ]
})
export class MemberGN1Component implements OnInit {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'name', 'category', 'contacts', 'docs', 'dates', 'edit' ];

  public allCategories: Category[] = [];

  // public arrayMembers: Member[] = []

  constructor (
    public _memberGn1Service: MemberGn1Service,
    private dialog: MatDialog,
    private _fileService: FileService,
    private _spinnerService: SpinnerService) {
  }

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit () {
    this.loadMembers();
  }


  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadMembers(){
    const waiting = this._spinnerService.show();

    const array: any[]=[]
    this._memberGn1Service.selectGN1()
    .subscribe((result)=>{
      result.forEach((item)=>{
        array.push({
          'id':item.id,
          ...item.data()
        })
      })
      //console.log(JSON.stringify(array))
      this.dataSource = new MatTableDataSource(array);
      this.dataSource.sort = this.sort
      waiting.close()

    })

    
  }

  openDialog (entity) {

    let data: Member = new Member();

    if (entity) {
      data = entity;
    }

    this.dialog.open(MemberGN1DialogComponent, {
      width: '1000px', //window.innerWidth.toString() + "px",
      height: '660px', //window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

  }

  exportToCsv () {

    const data = this.dataSource.data;

    let csvFile: any[] = []

    csvFile.push("" + ";" + "Usuários SBCCV" + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Nome' + ';'

    csvHeader += 'Categoria' + ';'
    csvHeader += 'Vigência' + ';'

    csvHeader += 'Situação' + ';'
    csvHeader += 'Saldo' + ';'

    csvHeader += 'Endereço' + ';'
    csvHeader += 'Número' + ';'
    csvHeader += 'Complemento' + ';'

    csvHeader += 'Cidade' + ';'
    csvHeader += 'UF' + ';'
    csvHeader += 'Pais' + ';'
    csvHeader += 'CEP' + ';'

    csvHeader += 'CPF' + ';'
    csvHeader += 'Celular' + ';'
    csvHeader += 'E-mail' + ';'
    csvHeader += 'Push' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((line) => {

      let csvLine: string;

      //  csvLine += "" + ";"
      //  csvLine += this.selectedProduct.name + ";"
      csvLine = "" + ";"
      csvLine += line.name + ";"
      csvLine += (line.subCategory ? line.subCategory.name : '') + ";"
      csvLine += line.annuity_from + ";"
      csvLine += line.situation + ";"
      csvLine += line.balance + ";"

      csvLine += line.address + ";"
      csvLine += line.number + ";"
      csvLine += line.complement + ";"

      csvLine += line.city + ";"
      csvLine += line.state + ";"
      csvLine += line.country + ";"

      csvLine += line.postalCode + ";"
      csvLine += line.cpf + ";"

      csvLine += line.cellPhone + ";"

      csvLine += line.email + ";"

      if(line.push){
        csvLine += 'Sim' + "\r\n"
      } else {
        csvLine += 'Não' + "\r\n"
      }
     
      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, "membros.csv");

  }

  readCSVFile(fileInput: any){

    console.log('fileInput: ' + fileInput.target.files[ 0 ].name)
    this._memberGn1Service.readCSVFile(fileInput)

  }
}

